export const VenueOptions = [
  { value: undefined, label: '' },
  { value: 1000, label: 'Yes' },
  { value: 1001, label: 'No' },
  { value: 2000, label: 'Branch/Office Premise' },
  { value: 3000, label: 'Rep\'s Home' },
  { value: 3001, label: 'Client\'s Home' },
  { value: 4000, label: 'Retailer (e.g. Restaurant, cafe etc.)' },
  { value: 4001, label: 'Event site of Road Show/ Retailer Tie-up/ Seminar' },
  { value: 5000, label: 'Non F2F - Video Conference' },
  { value: 5001, label: 'Non F2F - Telephone' },
  { value: 9999, label: 'Others' }
]
